import initialStates from '../../initialStates';
import {
    CLEAR_PRODUCT_STATE,
    FETCH_PRODUCT_LIST_FAILURE,
    FETCH_PRODUCT_LIST_REQUEST,
    FETCH_PRODUCT_LIST_SUCCESS,
} from './addBulkItemsInPurchaseOrder-actions';

const fetchProductsForPurchaseOrderWorker = (state = initialStates.addBulkItemsInPurchaseOrder, action) => {
    let newState = {};
    switch (action.type) {
    case FETCH_PRODUCT_LIST_REQUEST:
        newState = Object.assign({}, state, { isLoading: true });
        break;
    case FETCH_PRODUCT_LIST_SUCCESS:
        newState = Object.assign({}, state, {
            isLoading: false,
            data: action.data.content,
            page: action.data.number,
            size: action.data.size,
            totalElements: action.data.totalElements,
            filters: action.filters,
            warehouseId: action.warehouseId,
        });
        break;
    case FETCH_PRODUCT_LIST_FAILURE:
        newState = Object.assign({}, state, { isLoading: false });
        break;
    case CLEAR_PRODUCT_STATE:
        newState = initialStates.addBulkItemsInPurchaseOrder;
        break;
    default:
        newState = state;
    }
    return newState;
};

export default fetchProductsForPurchaseOrderWorker;
